module.exports = __webpack_public_path__ + "img/messageIcon_Inactive.14c2af7b.png";